<template>
  <div v-if="isopen" class="container">
    <i class="el-icon-close" @click="isopenChange" />
    <div class="content_video" :style="{ marginTop: marginTopHeight }">
      <!-- 使用组件video-player -->
      <video-player
        ref="videoPlayer"
        class="video-player vjs-custom-skin"
        :playsinline="true"
        :options="playerOptions"
        @pause="onPlayerPause($event)"
        @play="onPlayerPlay($event)"
      />
    </div>
  </div>
</template>

<script>
// 组件内引用vue-video-player插件
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      playerOptions: {
        controls: true,
        // 是否显示控制栏
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        // 播放速度
        autoplay: false,
        // 如果true,浏览器准备好时开始回放。
        muted: false,
        // 默认情况下将会消除任何音频。
        loop: false,
        // 导致视频一结束就重新开始。
        preload: 'auto',
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src:
              'https://www.sicau.edu.cn/__local/A/1E/52/E8093449CF93AF4E8960C131C04_09BD5DD1_1F12F030.mp4?e=.mp4',
            // 路径
            type: 'video/mp4',
            // 类型
          },
        ],
        poster:
          'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3612873308,1721476889&fm=26&gp=0.jpg',
        // 你的封面地址
        width: document.documentElement.clientWidth / 2,
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          //当前时间和持续时间的分隔符
          durationDisplay: true,
          //显示持续时间
          remainingTimeDisplay: false,
          //是否显示剩余时间功能
          fullscreenToggle: true,
          //全屏按钮
        },
      },
    };
  },
  computed: {
    marginTopHeight: function() {
      return window.innerHeight / 2 - 285 + 'px';
    },
    isopen() {
      return this.$store.state.isopen;
    },
  },
  methods: {
    isopenChange() {
      this.$store.commit('upisopen', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgba(17, 16, 17, 0.834);
  overflow: hidden;
  z-index: 99999;
  .el-icon-close {
    position: fixed;
    color: #f5f5f5;
    font-size: 30px;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }
  .el-icon-close:hover {
    transform: scale(1.5);
  }
}
.content_video .video-js .vjs-big-play-button {
  height: 1em;
  width: 1em;
  line-height: 1em;
  border-radius: 1em;
}
.content_video {
  text-align: left;
  margin: 0 auto;
  width: 50%;
}
</style>
